<template>
  <div class="table-footer">
    <div class="results">
      {{ $lang.messages.show }}
      <select
        class="pagination-select-btn"
        v-model="paginationParams.pageSize"
        @change="goToPage(1, false)"
      >
        <option
          v-for="index in pageSizeOptions"
          :key="`pagination-${index}`"
        >
          {{ index }}
        </option>
      </select>
      {{ $lang.messages.outOf }} {{ paginationParams.totalElements }} {{ $lang.messages.results }}
    </div>
    <div class="page-navigation">
      <img
        @click="prevPage"
        src="@/assets/images/payments/arrow_left_active.png"
        :class="{ 'arrow-passive': currentPage === 1 }"
      />
      <span
        v-for="index in this.selectablePages"
        :key="index"
        @click="goToPage(index, true)"
        class="page-number"
        :class="{ 'underline': index == currentPage}"
      >
        {{ index }}
      </span>
      <img
        @click="nextPage"
        src="@/assets/images/payments/arrow_right_active.png"
        :class="{ 'arrow-passive': currentPage === paginationParams.totalPages }"
      />
    </div>
    <div
      v-if="paginationParams.totalPages >= 1"
      class="page-jump"
    >
      {{ $lang.messages.jumpToPage }}
      <input
        type="number"
        :min="1"
        :max="paginationParams.totalPages"
        class="page-input"
        v-model="currentPage"
        @change="onJumpToPageChanged"
        @submit.prevent="onJumpToPageChanged"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: "FPPagination",
  props: {
    paginationParams: {
      type: Object,
      required: true,
      default: () => {}
    },
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      pageSizeOptions: [10, 15, 20],
      selectablePages:[1,2,3,4,5,6,7,8,9],
    };
  },
  mounted(){
    if(this.paginationParams.totalPages<9 && this.paginationParams.totalPages!==0){
      this.selectablePages = Array.from({length:this.paginationParams.totalPages},(_,i)=>i+1);
    }
  },
  watch:{
    paginationParams:{
      deep:true,
      handler(newVal){
        this.paginationParams = newVal;
        if(this.paginationParams.totalPages<9 && this.paginationParams.totalPages!==0){
          this.selectablePages = Array.from({length:this.paginationParams.totalPages},(_,i)=>i+1);
        }
      }
    }
  },
  methods: {
    nextPage() {
      if (this.currentPage * this.paginationParams.pageSize <  this.paginationParams.totalElements) {
        this.currentPage++;
        this.paginationParams.pageNumber = this.currentPage - 1;
        this.selectablePages = this.calculateSelectablePages(this.currentPage);
        this.onPaginationChanged();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.paginationParams.pageNumber = this.currentPage - 1;
        this.selectablePages = this.calculateSelectablePages(this.currentPage);
        this.onPaginationChanged();
      }
    },
    goToPage(index) {
      this.currentPage = index;
      this.paginationParams.pageNumber = this.currentPage - 1;
      this.selectablePages = this.calculateSelectablePages(this.currentPage);
      this.onPaginationChanged();
    },
    onJumpToPageChanged() {
      if (this.currentPage >= 1 && this.currentPage <= this.paginationParams.totalPages) {
        this.paginationParams.pageNumber = this.currentPage - 1;
      this.selectablePages = this.calculateSelectablePages(Number(this.currentPage));
        this.onPaginationChanged();
      }
    },
    onPaginationChanged() {
      this.$emit("onPaginationChanged", this.paginationParams);
    },
    calculateSelectablePages(goToPage){
      if(goToPage<6){
        if(this.paginationParams.totalPages<9){
          return Array.from({length:this.paginationParams.totalPages},(_,i)=>i+1);
        }
        else return [1,2,3,4,5,6,7,8,9];
      }
      else{
        const displayPages = [];
        if(this.paginationParams.totalPages<goToPage+4){
          const diff = this.paginationParams.totalPages - goToPage;
          const previousPagesNum = 9-diff-1;
          for(let i =-previousPagesNum;i<=diff;i++){
            displayPages.push(goToPage+i);
          }
        }
        else{
          for(let i=-4;i<5;i++){
            displayPages.push(goToPage+i);
          }
        }
        return displayPages;
      }
    }
    
  }
};
</script>
